import { render, staticRenderFns } from "./PaginadorComponente.vue?vue&type=template&id=acf4cf92&scoped=true"
import script from "./PaginadorComponente.vue?vue&type=script&lang=js"
export * from "./PaginadorComponente.vue?vue&type=script&lang=js"
import style0 from "./PaginadorComponente.vue?vue&type=style&index=0&id=acf4cf92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf4cf92",
  null
  
)

export default component.exports